import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'


function MfFundPerformance() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [DataFundPerformance, setDataFundPerformance] = useState([]);
    const [Shemedrop, setSheme] = useState('26');
    const [Performance, setPerformance] = useState('T');
    const [valueLi, setValueLi] = useState('1Week');
    const [loadingshow, setloadingshow] = useState(false);
    const [Valueschemename,setValueschemename] = useState([]);
    let getDataHoldingdrop, PageSize = 5;
    let navigate = useNavigate();


    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDropDividend = BaseURL + "MfHoldingDrop";
        // alert(`${getUrlMfTopHoldingDropDividend}/compare/-`)
        fetch(`${getUrlMfTopHoldingDropDividend}/compare/-`)
            .then((response) => response.json())
            .then((dataFundPerformance) => {
                getDataHoldingdrop = dataFundPerformance.data;
                setDataFundPerformance(getDataHoldingdrop);
                var schemename = getDataHoldingdrop[0].VCLASS;
                setValueschemename(schemename)
                
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "MfFundPerformance/";
        if (Performance === 'T') {
            // alert(`${getUrl}/15/${valueLi}/${Shemedrop}/ALL/${Performance}/ALL`)
            fetch(`${getUrl}/8/${valueLi}/${Shemedrop}/ALL/${Performance}/ALL`)
                .then((response) => response.json())
                .then((data) => {

                    setData(data.data);
                    setloadingshow(false);
                    // console.log(data.data)
                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }
        else {

            fetch(`${getUrl}/8/${valueLi}/${Shemedrop}/ALL/${Performance}/ALL`)
                .then((response) => response.json())
                .then((data) => {

                    setData(data.data);
                    setloadingshow(false);
                    // console.log(data.data)
                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }
    }, [Performance, Shemedrop, valueLi]);
    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>Fund Performance</h4>
                    <span className="moreContent" onClick={()=>{navigate("/MutualFund/Fund-Performance")}}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className='mf-common fund-performance-main'>
                        <div className="fund-per-drop">
                            <div className='holdings-select'>
                                {/* aria-label="Select Category" */}
                                <select aria-label="Select Category" onChange={(event) => setSheme(event.target.value)}>
                                    <option>Select Category</option>
                                    {DataFundPerformance && DataFundPerformance.map(
                                        ({ VCLASSCODE, VCLASS }) => (
                                            <option value={VCLASSCODE} selected={Valueschemename === VCLASS}>{VCLASS}</option>
                                        )
                                    )}
                                </select>

                            </div>
                            <div className='holdings-select'>
                                {/* aria-label="Select Category" */}
                                <select aria-label="Select Category" onChange={(event) => setPerformance(event.target.value)}>
                                    <option>Select Category</option>
                                    <option value='T' selected={Performance === 'T'}>Top performance</option>
                                    <option value='B'>Bottom Performance</option>

                                </select>
                            </div>
                            <div class="MF-Performance-dates">
                                <ul>
                                    <li id="1Week" data-value="1Week" className={(valueLi === "1Week") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1W</li>
                                    <li data-value="1Month" className={(valueLi === "1Month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1M</li>
                                    <li data-value="3month" className={(valueLi === "3month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>3M</li>
                                    <li data-value="6month" className={(valueLi === "6month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>6M</li>
                                    <li data-value="1year" className={(valueLi === "1year") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1Y</li>
                                    <li data-value="3year" className={(valueLi === "3year") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>3Y</li>
                                </ul>
                            </div>
                        </div>
                        <div className='mf-table table-responsive gainer-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-left'>Scheme Name</th>
                                        <th className='text-right'>% Returns</th>
                                    </tr>
                                </thead>
                                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                {(() => {
                                    if (valueLi === "1Week") {
                                        return (
                                            <tbody>
                                                {(data != null) && data.map(({ Sch_Name, week1 }) => (
                                                    <tr>
                                                        <td className='text-left'>{Sch_Name}</td>
                                                        <td className='text-right'>{(week1 != null) ? week1.toFixed(2) : 0}</td>
                                                        {/* {(month1 != null) ? month1.toFixed(2) : 0} */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )
                                    }
                                    else if (valueLi === "1Month") {
                                        return (
                                            <tbody>
                                                {(data != null) && data.map(({ Sch_Name, month1 }) => (
                                                    <tr>
                                                        <td className='text-left'>{Sch_Name}</td>
                                                        <td className='text-right'>{(month1 != null) ? month1.toFixed(2) : 0} </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )
                                    }
                                    else if (valueLi === "3month") {
                                        return (
                                            <tbody>

                                                {(data != null) && data.map(({ Sch_Name, month3 }) => (
                                                    <tr>
                                                        <td className='text-left'>{Sch_Name}</td>
                                                        <td className='text-right'> {(month3 != null) ? month3.toFixed(2) : 0} </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )
                                    }
                                    else if (valueLi === "6month") {
                                        return (
                                            <tbody>

                                                {(data != null) && data.map(({ Sch_Name, month6 }) => (
                                                    <tr>
                                                        <td className='text-left'>{Sch_Name}</td>
                                                        <td className='text-right'>{(month6 != null) ? month6.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )
                                    }
                                    else if (valueLi === "1year") {
                                        return (
                                            <tbody>

                                                {(data != null) && data.map(({ Sch_Name, year1 }) => (
                                                    <tr>
                                                        <td className='text-left'>{Sch_Name}</td>
                                                        <td className='text-right'>{(year1 != null) ? year1.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )
                                    }
                                    else if (valueLi === "3year") {
                                        return (
                                            <tbody>

                                                {(data != null) && data.map(({ Sch_Name, year3 }) => (
                                                    <tr>
                                                        <td className='text-left'>{Sch_Name}</td>
                                                        <td className='text-right'>{(year3 != null) ? year3.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )
                                    }
                                })()}
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                        </div>
                        {/* {(data != null && data != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(data.length != null) ? data.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                    </div>
                </Container>
            </div>
        </>
    )
}

export default MfFundPerformance